import { durationType } from "./SchedulingSection/form.types";

export const meetingTypes = [
    {
      label: "Virtual meeting",
      value: "Virtual Meeting",
    },
    {
      label: "Face-to-face meeting",
      value: "Face-to-Face",
    },
    {
      label: "Telephonic meeting",
      value: "Telephone Call",
    },
  ];
  
  export const meetingDurations = [
    {
      label: "15 minutes",
      type: durationType.minute,
      duration: 15,
    },
    {
      label: "30 minutes",
      type: durationType.minute,
      duration: 30,
    },
    {
      label: "45 minutes",
      type: durationType.minute,
      duration: 45,
    },
    {
      label: "1 hour",
      type: durationType?.hour,
      duration: 1,
    },
    {
      label: "1.5 hours",
      type: durationType?.hour,
      duration: 1.5,
    },
    {
      label: "2 hours",
      type: durationType?.hour,
      duration: 2,
    },
  ];